import { render } from "./FinancialPrivacyButton.vue?vue&type=template&id=02a3259a&scoped=true&ts=true"
import script from "./FinancialPrivacyButton.vue?vue&type=script&lang=ts"
export * from "./FinancialPrivacyButton.vue?vue&type=script&lang=ts"

import "./FinancialPrivacyButton.vue?vue&type=style&index=0&id=02a3259a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a3259a"]])

export default __exports__